import VueMq from "vue-mq"
import VueModalTor from "vue-modaltor"
import Toast from "vue-toastification"
import VTooltip from "v-tooltip"
import JsonClient from "@/plugins/jsonclient"
import LocalStorage from "@/plugins/localStorage"
import Gdpr from "@/plugins/gdpr"
import GoogleAnalytics from "@/plugins/googleAnalytics"

const configless = plugin => [plugin, {}];

const plugins = [
    [VueMq, {
        breakpoints: {
            xsmall: 540, //up to 540 -> xsmall
            small: 900, //from 540 up to 900 -> small
            medium: 1280,
            large: 1440,
            xlarge: 1920,
            xxlarge: Infinity,
        },
        defaultBreakpoint: "medium",
    }],
    configless(VTooltip),
    configless(VueModalTor),
    [Toast, {
        position: "bottom-center",
        maxToasts: 4,
        transitionDuration: 350,
        timeout: 4000,
    }],
    [JsonClient, {
        config($json){
            const meta = document.querySelector("meta[name='csrf-token']");
			const csrfToken = !!meta ? meta.getAttribute("content") : "";

            // Add CSRF token
            ["GET", "POST", "PUT", "DELETE", "PATCH"]
            .forEach(method => {
				const csrfKey = "_csrf";
				const defaults = $json.defaults[method];

				["data", "qs"]
				.forEach(repo => {
					if(repo in defaults)
						defaults[repo][csrfKey] = csrfToken;
				});

                ["X-XSRF-TOKEN", "X-CSRF-TOKEN"]
                .forEach(header => defaults.headers[header] = csrfToken);
            });
        }
	}],
	[LocalStorage, {
		config(store){
			// const plugins = require("store/plugins/all");
			const plugins = require("store/plugins/v1-backcompat");
			plugins.forEach(plugin => store.addPlugin(plugin));
		},
	}],
	[Gdpr, {
		factory(Vue, storeKey){
			const { GdprManagerBuilder, GdprStorage } = require("gdpr-guard");
			return GdprManagerBuilder.make()
				.startRequiredGroup(GdprStorage.LocalStorage, "RGPD", "Gestion des préférences relatives à la protection des données")
					.withEnabledGuard(storeKey, "Sauvegarde de vos préférences RGPD")
                    .withEnabledGuard(`${storeKey}__version`, "Version des paramètres RGPD")
				.endGroup()
				.startGroup(GdprStorage.Cookie, "Trafic", "Analyse du trafic des visiteurs")
					.enabled()
                    .withEnabledGuard("_ga", "Google Analytics")
                    .startRequiredGuard()
                        .withName("vue-tabs-component.cache")
                        .withDescription("Cache d'onglet de la page tarauds et filières")
                        .storedIn(GdprStorage.LocalStorage)
                    .endGuard()
                .endGroup()
                .startRequiredGroup(GdprStorage.Cookie, "Sécurité", "Mesures de sécurité")
					.withEnabledGuard("XSRF-TOKEN", "Jeton prévenant la soumission frauduleuse de formulaire")
					.withEnabledGuard("adonis-session", "Identifiant de session")
					.withEnabledGuard("adonis-session-values", "Jetons de session")
                    .startRequiredGuard()
                        .withName("Adresse IP")
                        .withDescription("Utilisation dans la journalisation des visites")
                        .storedIn(GdprStorage.Server)
                    .endGuard()
                .endGroup()
			.build();
		},
	}],
	configless(GoogleAnalytics),
];

export {
    plugins,
}
